// @flow

import Roarr from 'roarr';

const Logger = Roarr
  .child({
    program: 'watchdog-timer',
  });

export default Logger;
